import cf from './cf';
import c00v1 from './c00v1_20211024';

export default class c00vmail extends c00v1 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.d_viewDefs = {
      class: 'c00vm',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
